<div class="relative min-h-screen flex flex-col">
    <!--Navbar-->
    <app-navbar></app-navbar>
    <!-- Navbar End -->

    <!-- Top Banner Section Start -->
    <div class="flex-grow overflow-x-hidden">
        <div class="mb-10 banner-container">
            <div class="grid grid-cols-12">
                <div class="col-span-12">
                    <div class="w-full h-[450px] banner-wrapper">
                        <img src="/assets/images/banners/about-banner.png" alt=""
                            class="object-cover w-full h-full">
                            <div class="flex items-center h-full banner-container-inner">
                                <div class="container mx-auto">
                                    <div class="p-[30px] text-center mt-[7em]">
                                        <h1 class="my-0 mb-2 text-[2em] sm:text-5xl md:text-[2.5em] text-white">
                                            <span class="font-bold mr-2">About MedEase</span>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Top Banner Section End -->

        <!-- About section start -->
            <section class="about-sec px-[1em] pt-0 md:pt-[100px] lg:pb-[100px]">
                <div class="container mx-auto">
                    <div class="grid grid-cols-12 items-center items-center">
                        <div class="col-span-12 lg:col-span-6">
                            <div class="about-img">
                                <img src="/assets/images/about/about-img.jpg" alt="" class="w-[100%] lg:w-auto">
                            </div>
                        </div>
                        <div class="col-span-12 lg:col-span-6">
                            <div class="about-content">
                                <div class="about-title max-w-[640px]">
                                    <span class="subtitle inline-flex text-[#45a6d1] text-[16px] mb-[10px] font-medium">About Us</span>
                                    <h3 class="mb-5 text-[30px] md:text-[40px] lg:text-[60px] font-bold text-[#112c76] leading-[1.2em] mt-0">We Provide Essential
                                        Service For Your Health</h3>
                                </div>
                                <div class="about-para">
                                    <p class="mb-4">
                                        At MedEase, we believe that healthcare should be accessible and hassle-free. Our platform is designed with you in mind, allowing you to browse through a wide range of specialists, book appointments, and consult with doctors—all online. No more long waits at clinics or stressful scheduling. With just a few clicks, you can connect with experienced healthcare professionals who are ready to provide personalized care tailored to your needs. Whether it's managing a chronic condition or seeking a second opinion, Medease brings healthcare to your doorstep, making it easier and more efficient than ever.
                                    </p>
                                    <p>
                                        With Medease, your healthcare is truly in your hands, giving you control over when and how you receive care. Our user-friendly platform not only offers convenience but also empowers you to make informed decisions by providing detailed profiles of doctors and specialists. You can review qualifications, specialties, and patient reviews before booking, ensuring you find the right match for your needs. Our mission is to bridge the gap between patients and healthcare providers, making quality care more accessible, timely, and patient-centered, all from the comfort of your home.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        <!-- About section end -->

        <!-- Process section start -->
            <section class="process-sec px-[1em] xxl:px-0 py-[70px] lg:pt-0 lg:pb-[120px] relative">
                <div class="container mx-auto">
                    <div class="grid grid-cols-12">
                        <div class="col-span-12 lg:col-span-5">
                            <div class="process-title">
                                <span class="subtitle inline-flex text-[#45a6d1] text-[16px] mb-[10px] font-medium">Book. Confirm. Attend</span>
                                <h3 class="title my-0 font-bold text-[30px] md:text-[40px] lg:text-[60px] text-[#112c76]">How it
                                    Works?</h3>
                            </div>
                        </div>
                        <div class="col-span-12 lg:col-span-4">
                            <p class="mb-0 max-w-[90%]">
                                MedEase offers a simple and efficient way to book doctor appointments online. Easily browse available doctors, select a convenient time, and confirm your appointment—all from the comfort of your home. Enjoy a seamless experience designed for your health and convenience.
                            </p>
                        </div>
                        <div class="col-span-12 lg:col-span-3 my-4 lg:my-0">
                            <a href="/doctors"
                                class="bg-[#45a6d1] text-white inline-block text-14px font-medium py-[17px] px-[30px] rounded-[6px] hover:bg-[#112c76] ease-in duration-300">Visit
                                Doctors</a>
                        </div>
                    </div>
                    <div class="grid grid-cols-12 gap-4 relative process-solution-container mt-[2em]">
                        <div class="col-span-12 lg:col-span-4">
                            <div class="process-solution mb-[30px] flex">
                                <div class="process-icon">
                                    <span
                                        class="w-[110px] h-[110px] bg-[#fff] rounded-[6px] shadow-[0_0_10px_5px_rgba(0,0,0,0.03)] mr-[28px] text-[#45a6d1] text-[20px] flex items-center justify-center">
                                        <span class="material-symbols-outlined text-[56px]">search</span>
                                    </span>
                                </div>
                                <div class="process-description">
                                    <h5 class="mt-0 lg:mb-[5px] text-black text-[20px] font-medium">Search for Doctors</h5>
                                    <p class="mb-0 ">
                                        Browse through our extensive list of experienced qualified doctors. Our user-friendly search feature helps you find the right healthcare provider quickly.
                                    </p>
                                    <span class="text-[18px] block font-medium text-[#45a6d1] my-[18px]">Step 1</span>
                                    <span
                                        class="pulsive-dot relative inline-block w-[12px] h-[12px] rounded-full bg-[#45a6d1] ml-[6px]"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-span-12 lg:col-span-4">
                            <div class="process-solution mb-[30px] flex">
                                <div class="process-icon">
                                    <span
                                        class="w-[110px] h-[110px] bg-[#fff] rounded-[6px] shadow-[0_0_10px_5px_rgba(0,0,0,0.03)] mr-[28px] text-[#45a6d1] text-[20px] flex items-center justify-center">
                                        <span class="material-symbols-outlined text-[56px]">calendar_month</span>
                                    </span>
                                </div>
                                <div class="process-description">
                                    <h5 class="mt-0 lg:mb-[5px] text-black text-[20px] font-medium">Select Your Appointment</h5>
                                    <p class="mb-0 ">
                                        Choose a suitable date and time from the available slots. With just a few clicks, you can book your appointment seamlessly without any hassle.
                                    </p>
                                    <span class="text-[18px] block font-medium text-[#45a6d1] my-[18px]">Step 2</span>
                                    <span
                                        class="pulsive-dot relative inline-block w-[12px] h-[12px] rounded-full bg-[#45a6d1] ml-[6px]"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-span-12 lg:col-span-4">
                            <div class="process-solution mb-[30px] flex">
                                <div class="process-icon">
                                    <span
                                        class="w-[110px] h-[110px] bg-[#fff] rounded-[6px] shadow-[0_0_10px_5px_rgba(0,0,0,0.03)] mr-[28px] text-[#45a6d1] text-[20px] flex items-center justify-center">
                                        <span class="material-symbols-outlined text-[56px]">verified_user</span>
                                    </span>
                                </div>
                                <div class="process-description">
                                    <h5 class="mt-0 lg:mb-[5px] text-black text-[20px] font-medium">Confirm and Attend</h5>
                                    <p class="mb-0 ">
                                        Once your appointment is booked, you’ll receive a confirmation via email or SMS. Simply arrive at your chosen hospital or clinic on the scheduled date for your consultation.
                                    </p>
                                    <span class="text-[18px] block font-medium text-[#45a6d1] my-[18px]">Step 3</span>
                                    <span
                                        class="pulsive-dot relative inline-block w-[12px] h-[12px] rounded-full bg-[#45a6d1] ml-[6px]"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        <!-- Process section end -->

        <!-- Banner section start -->
            <section class="relative bg-opacity-90 video-banner-sec bg-[#112c76] pt-[70px]  md:pt-[135px] pb-[70px]">
                <div class="container mx-auto relative z-10">
                    <div class="grid grid-cols-12 gap-4 items-center">
                        <div class="col-span-12 sm:col-span-5">
                            <div class="p-6 video-banner-about">
                                <div class="mb-6 video-about-title">
                                    <h3
                                        class="text-[30px] md:text-[40px] lg:text-[60px] font-semibold text-white leading-[1.3em]">
                                        Why Choose MedEase?
                                    </h3>
                                </div>
                                <div class="video-about-content">
                                    <p class="mb-[30px] text-white opacity-80 leading-[1.8em]">
                                        Choosing Medease means choosing a more convenient, efficient, and patient-focused healthcare experience. Our platform is designed to make your healthcare journey smoother by offering reliable online appointment booking and access to top doctors, all from the comfort of your home.
                                    </p>
                                    <div class="flex mb-[30px] items-center">
                                        <div>
                                            <span class="material-symbols-outlined text-white w-auto h-auto text-[44px] mr-[20px]">touch_app</span>
                                        </div>
                                        <div>
                                            <h5 class="text-white mb-[14px] text-[18px]">Convenience at Your Fingertips</h5>
                                            <p class="text-white opacity-80">Say goodbye to long queues and manual bookings. With Medease Stay at Home, you can schedule appointments at your preferred time, making healthcare more accessible and time-efficient.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="flex items-center">
                                        <div>
                                            <span class="material-symbols-outlined text-white w-auto h-auto text-[44px] mr-[20px]">verified</span>
                                        </div>
                                        <div>
                                            <h5 class="text-white mb-[14px] text-[18px]">Trusted and Verified Doctors</h5>
                                            <p class="text-white opacity-80">We connect you with highly qualified and verified healthcare professionals, ensuring that you receive expert medical attention whenever you need it.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-span-12 sm:col-span-6">
                            <div class="video-img-sec relative w-[100%] h-[100%] ml-0 md:ml-[100px] p-6 md:p-0">
                                <div class="grid grid-cols-12 gap-4">
                                    <div class="col-span-12 md:col-span-6">
                                        <div class="w-[100%] md:w-[300px]">
                                            <img src="/assets/images/choose/choose-4.png" alt="" class="img-1">
                                            <div class="about-experience mt-4">
                                                <div class="about-experience-icon">
                                                    <span class="material-symbols-outlined text-white w-auto h-auto text-[64px]">security</span>
                                                </div>
                                                <p class="text-start text-[#000]">Years Of <br> Quality Service</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-span-12 md:col-span-6 hidden lg:block">
                                        <img src="/assets/images/choose/choose-6.png" alt="" class="img-2">
                                        <img src="/assets/images/choose/choose-7.png" alt="" class="img-3 mt-4">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-[#45a6d1] py-8 mt-8 ml-20 relative z-10 bg-cover bg-center our-features"
                        style="background-image: url('/assets/images/pattern-2.png');">
                        <div class="grid grid-cols-2 md:grid-cols-4 gap-4 text-white">
                            <div class="text-center mb-[30px]">
                                <span class="material-symbols-outlined text-white w-auto h-auto text-[54px] mr-[20px]">volunteer_activism</span>
                                <p class="mb-[20px]">Trusted Healthcare Partner</p>
                            </div>
                            <div class="text-center mb-[30px]">
                                <span class="material-symbols-outlined text-white w-auto h-auto text-[54px] mr-[20px]">event_note</span>
                                <p class="mb-[20px]">Easy and Flexible Scheduling</p>
                            </div>
                            <div class="text-center mb-[30px]">
                                <span class="material-symbols-outlined text-white w-auto h-auto text-[54px] mr-[20px]">key</span>
                                <p class="mb-[20px]">Safe and Secure Consultations</p>
                            </div>
                            <div class="text-center mb-[30px]">
                                <span class="material-symbols-outlined text-white w-auto h-auto text-[54px] mr-[20px]">schedule</span>
                                <p class="mb-[20px]">Save Time and Avoid Crowds</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        <!-- Banner section end -->

        <!-- Faq section start -->
            <section class="faq-sec mt-[220px] px-3 lg:px-0 pt-0 pb-[70px] md:py-[100px]">
                <div class="container mx-auto">
                    <div class="grid grid-cols-12 items-center">
                        <div class="col-span-12 xl:col-span-6">
                            <div class="faq-title">
                                <div class="faq-img text-center">
                                <img src="/assets/images/faq/faq-1.png" alt="" class="w-[100%] xl:w-[80%] h-[500px] lg:h-[650px] object-cover rounded-[15px]">
                                </div>
                            </div>
                        </div>
                        <div class="col-span-12 xl:col-span-6 mt-[2em] xl:mt-0">
                            <div class="faq-title">
                                <span class="subtitle inline-flex text-[#45a6d1] text-[16px] mb-[10px] font-medium">FAQ</span>
                                <h3 class="title mt-0 mb-[20px] font-bold text-[30px] md:text-[40px] lg:text-[60px] text-[#112c76] max-w-[640px] leading-[1.2em]">
                                    We Provide Best Frequency And Questions</h3>
                            </div>
                            <p class="max-w-[90%]">
                                In our FAQ section, we’ve gathered the most commonly asked questions to provide you with quick and clear answers. Whether you're curious about how to book an appointment, consult a doctor online, or manage your account, our FAQs are here to help. We’re committed to making your experience with Medease Stay at Home as smooth and straightforward as possible.
                            </p>
                            <div class="faq-content w-[90%] mt-[2em]">
                                <mat-accordion>
                                    <!-- <mat-expansion-panel hideToggle>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title> This is the expansion title </mat-panel-title>
                                        <mat-panel-description> This is a summary of the content </mat-panel-description>
                                    </mat-expansion-panel-header>
                                    <p>This is the primary content of the panel.</p>
                                    </mat-expansion-panel> -->
                                    <mat-expansion-panel [expanded]="step() === 0" (opened)="setStep(0)">
                                    <mat-expansion-panel-header class="faq-head">
                                        <mat-panel-title class="faq-title"> What is Medease?</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p>
                                        Medease is an online healthcare platform that allows patients to easily search for doctors, book appointments, and manage healthcare services. It provides access to various specialists across multiple hospitals and branches, streamlining the appointment booking process.
                                    </p>
                                    </mat-expansion-panel>
                                    <mat-expansion-panel [expanded]="step() === 1" (opened)="setStep(1)">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title class="faq-title">How do I register on Medease?</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p>
                                        Click on the 'Sign Up' button at the top of the homepage.
                                        Provide your personal information such as name, phone number, and email address.
                                        Create a secure password.
                                        You will receive a verification email to confirm your registration. Once verified, you can log in and start booking appointments.
                                                                    </p>
                                    </mat-expansion-panel>
                                    <mat-expansion-panel [expanded]="step() === 2" (opened)="setStep(2)">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title class="faq-title">How can I book an appointment with a doctor?</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p>
                                        Log in to your account.
                                        Use the search function to find doctors by specialty, location, or hospital.
                                        Select your preferred doctor and view available time slots.
                                        Choose a convenient date and time, and confirm the booking.
                                        You will receive a confirmation message with your appointment details.
                                    </p>
                                    </mat-expansion-panel>
                                    <mat-expansion-panel [expanded]="step() === 3" (opened)="setStep(3)">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title class="faq-title">Can I book an appointment without an account?</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p>
                                        No, you need to have an account to book appointments. Creating an account allows you to track your appointments, access your medical history, and receive notifications.
                                    </p>
                                    </mat-expansion-panel>
                                    <mat-expansion-panel [expanded]="step() === 4" (opened)="setStep(4)">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title class="faq-title">How do I reschedule or cancel an appointment?</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p>
                                        Log in to your account and go to the 'My Bookings' section.
                                        Select the appointment you wish to modify.
                                        Choose the 'Reschedule' option to pick a new date/time, or 'Cancel' to cancel your booking.
                                        Please note that certain doctors may have cancellation policies, and fees may apply if you cancel late.
                                    </p>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        <!-- Faq section end -->

        
    </div>

    <!-- Footer Start -->
     <app-message></app-message>
    <app-footer></app-footer>
    <!-- Footer End -->

</div>